import { Dialog } from "@/components/shared/dialog";
import { ArticleCategoryContent } from "./ArticleCategoryContent";
import { Text } from "@radix-ui/themes";
import { useArticleCategorySelector } from "@/v2/shared/hooks/useArticleCategorySelector";

export interface ArticleCategoryDialogProps {
  source: string;
  title: string;
  description: string;
  onClose: () => void;
  onSave: () => void;
  open?: boolean;
  maxWidth?: number;
  loadingText?: string;
  loadingSubtext?: string;
  saveButtonText?: string;
  cancelButtonText?: string;
}

export function ArticleCategoryDialog({
  source,
  title,
  description,
  onClose,
  onSave,
  open = true,
  maxWidth = 540,
  loadingText = "Loading...",
  loadingSubtext = "Please wait while we fetch your configuration",
  saveButtonText = "Save Configuration",
  cancelButtonText = "Cancel",
}: ArticleCategoryDialogProps) {
  const articleCategorySelector = useArticleCategorySelector({
    source,
    onClose,
  });
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <Dialog.Content
        size="medium"
        style={{ maxWidth, maxHeight: "90vh", height: "auto" }}
      >
        <Dialog.Title>
          {title}
          <Dialog.Close />
        </Dialog.Title>

        <div className="Main" style={{ padding: "15px" }}>
          <Text size="2" mb="4" color="gray">
            {description}
          </Text>
          <div style={{ height: "16px" }} />
          <ArticleCategoryContent
            {...articleCategorySelector}
            source={source}
            onSave={onSave}
            onClose={onClose}
            loadingText={loadingText}
            loadingSubtext={loadingSubtext}
            saveButtonText={saveButtonText}
            cancelButtonText={cancelButtonText}
          />
        </div>
      </Dialog.Content>
    </Dialog>
  );
}
